import type { PassengerPassengerTagRead } from 'src/common/external/bambi-api/bambiApi';
import { Tag } from 'src/common/tags/Tag/Tag';

export function PassengerInfoFormTags({
  tags,
}: {
  tags: PassengerPassengerTagRead[];
}) {
  return (
    <div className="mt-1 flex flex-row flex-wrap gap-1">
      {tags.map((tag) => (
        <Tag
          key={tag.id}
          label={tag.tag_name}
          color={tag.color_hex}
          data-testid={`passenger-tag-${tag.id}`}
        />
      ))}
    </div>
  );
}
